import React, { useState, useEffect } from "react";
import { Result } from "antd";
import MainWrapper from "../components/MainWrapper";
import SpinerIndicator from "../components/SpinerIndicator";
import { useDispatch, useSelector } from "react-redux";
import { getVerifyManualTransactionIdr } from "../redux/actions/getVerifyManualTransaction";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import AlertMessageWrapper from "../components/AlertMessageWrapper";
import ButtonWrapper from "../components/ButtonWrapper";
import { Select } from "antd";
import IdrPaymentMethodSelectCard from "../components/IdrPaymentMethodSelectCard";
import { language } from "../utils/language";

const IdrTransactionInfo = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [lang, setLang] = useState("bi");

  const verifyManualTransactionState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { isLoading, error } = verifyManualTransactionState;

  // const { lang } = useSelector((state) => state.languageSelectorReducer);
  const postQrInitManualState = useSelector(
    (state) => state.postQrInitManualReducer
  );
  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = postQrInitManualState;

  useEffect(() => {
    dispatch(getVerifyManualTransactionIdr(params.id));
    dispatch({
      type: "DEFAULT_LANGUAGE",
      payload: "bi",
    });
  }, []);

  const errorMessage = () => {
    if (error) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper
                  message={language[lang].idrMethod.selectPaymentMethod}
                />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    } else if (qrInitError == "Error: auto trx id is not valid or expired") {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <AlertMessageWrapper
                message={language[lang].idrMethod.selectPaymentMethod}
              />
            }
          />
        </div>
      );
    } else if (
      qrInitError == "ConflictException: Qr Code status has been changed"
    ) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <AlertMessageWrapper
                message={language[lang].idrMethod.contactSupport}
              />
            }
          />
        </div>
      );
    } else if (qrInitError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <Result
            status="500"
            extra={
              <>
                <AlertMessageWrapper message={qrInitError} />
                <ButtonWrapper
                  border={true}
                  onClick={() => window.location.reload()}
                  className="mt-3"
                  text="Refresh"
                  height="40px"
                  fontSize="16px"
                  type="primary"
                />
              </>
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    errorMessage();
  }, [qrInitError, error]);

  return (
    <div className="" style={{ height: "100vh" }}>
      <MainWrapper>
        {isLoading ? (
          <SpinerIndicator fontSize="50px" color="#fff" />
        ) : error || qrInitError ? (
          errorMessage()
        ) : (
          <IdrPaymentMethodSelectCard />
        )}
      </MainWrapper>
    </div>
  );
};

export default IdrTransactionInfo;
